import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import { TextArea } from "atoms/TextArea";

import { QuizStepProps } from "../useQuestionnaire";

import YesNo from "./components/YesNo";

export const WeightLossMedsInPast = (props: QuizStepProps) => {
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);
  const hasError = !!props.errors?.WeightLossMedsInPast;

  const handleChange = (value: string) => {
    props.handleStepData("WeightLossMedsInPastQuestion", value);
    props.handleStepData("WeightLossMedsInPast", "");
    if (value === "No") {
      setLastUpdate({ key: "WeightLossMedsInPastQuestion", value });
    }
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex h-full flex-col">
      <p className="pb-4 font-serif text-h3">
        Have you taken any prescription medications to lose weight before? If
        so, please include date range, name, dose, and frequency.
      </p>
      <div className="flex gap-3">
        <YesNo
          value={props.data.WeightLossMedsInPastQuestion}
          onChange={(value) => handleChange(value)}
        />
      </div>
      <div
        hidden={props.data.WeightLossMedsInPastQuestion !== "Yes"}
        className="mt-4"
      >
        <TextArea
          label="Weight Loss Medications in Past"
          value={props.data.WeightLossMedsInPast as string}
          invalid={hasError}
          onChange={(value) =>
            props.handleStepData("WeightLossMedsInPast", value)
          }
        />
        {hasError && (
          <p className="mt-2 text-sm text-red">
            Please add information requested above.
          </p>
        )}
      </div>
      <div
        hidden={props.data.WeightLossMedsInPastQuestion !== "Yes"}
        className="mt-auto"
      >
        <Button fullWidth onClick={() => props.next?.()}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
